import React, { useState, useEffect } from 'react';
import { Navbar } from '../layout/Navbar';
import { Trophy } from 'lucide-react';
import { LeaderboardPanel } from './LeaderboardPanel';
import { getLeaderboard } from '../../services/agentService';

export const Leaderboard = () => {
    const [leaderboardData, setLeaderboardData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchLeaderboard = async () => {
            try {
                const data = await getLeaderboard();
                setLeaderboardData(data.agents || []);
            } catch (error) {
                console.error("Error fetching leaderboard:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchLeaderboard();
    }, []);

    return (
        <div className="min-h-screen bg-black text-foreground pb-20">
            <Navbar />
            <div className="container mx-auto px-4 pt-32">
                <div className="text-center mb-16">
                    <h1 className="text-4xl md:text-5xl font-black bg-clip-text text-transparent bg-gradient-to-r from-primary to-primary/60 mb-6 inline-flex items-center gap-4">
                        <Trophy className="text-primary w-10 h-10" /> Global Leaderboard
                    </h1>
                    <p className="text-xl text-muted-foreground">Top performers in the PredictClaw ecosystem.</p>
                </div>

                {loading ? (
                    <div className="flex flex-col items-center justify-center py-20">
                        <div className="w-12 h-12 border-4 border-primary/30 border-t-primary rounded-full animate-spin mb-4" />
                        <p className="text-muted-foreground">Synchronizing agent performance data...</p>
                    </div>
                ) : (
                    <LeaderboardPanel leaderboardData={leaderboardData} />
                )}
            </div>
        </div>
    );
};

